import React from 'react';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import {
  FDHeadlineText, FDIcon, FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import BigPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/BigPicklistControl';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import { useIncomeCategoryGroupData } from 'Hooks/useIncomeCategoryGroupData';


function ActivePassiveIncomesLayout() {
  useScrollTopOnMount();
  const {
    resource,
    handleChange,
    onSubmit: onSubmitMetaForm,
    metaOverrideSet,
  } = useMetaLayoutContext();
  const {
    getGroups,
    getIncomeCategoryGroupIcon,
    getIncomeCategoryGroupTitle,
    getIncomeCategoryGroupSubtitle,
    getIncomeCategoryGroupOptions,
  } = useIncomeCategoryGroupData();

  const groups = getGroups(resource);

  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'}>
      <PageContentTop
        title={resource.attr('primaryText')}
      />
      <FDStack direction={'column'} spacing={2} alignItems={'center'}>
        {groups.map((group) => (
          <FDPaper appearance={'outlined'} width={'100%'} padding={3}>
            <FDStack direction={'column'} spacing={2} alignItems={'center'}>
              <FDIcon icon={getIncomeCategoryGroupIcon(group)} size={'lg'} />
              <FDHeadlineText value={getIncomeCategoryGroupTitle(group)} />
              <FDTitleText color={'textDisabled'} size={'sm'} value={getIncomeCategoryGroupSubtitle(group)} />
              <BigPicklistControl
                fullWidth
                selectId={'options'}
                multiple
                testName={'qualitative-question'}
                value={resource?.attr('options') || []}
                options={getIncomeCategoryGroupOptions(resource, group)}
                onChange={(values, value) => {
                  const metaField = metaOverrideSet.applyOverrides(resource.meta().field('options'));
                  const transformValue = metaField.attr('_transformValue') || null;

                  let v = values;
                  if (transformValue) {
                    v = transformValue(value, values, resource);
                  }

                  return handleChange('options', v);
                }}
              />
            </FDStack>
          </FDPaper>
        ))}
        <SurveyStepFooter
          onSubmit={onSubmitMetaForm}
          nextDisabled={resource?.attr('options')?.length === 0}
        />
      </FDStack>
    </FDStack>
  );
}

ActivePassiveIncomesLayout.propTypes = {};

ActivePassiveIncomesLayout.defaultProps = {};

export { ActivePassiveIncomesLayout };
